'use client';

import { createContext, ReactNode, useContext, useState } from 'react';

interface FloatingInputBarContextValue {
    height: number;
    setHeight: (h: number) => void;
}

const FloatingInputBarContext = createContext<FloatingInputBarContextValue>({
    height: 0,
    setHeight: () => {},
});

export function FloatingInputBarProvider({ children }: { children: ReactNode }) {
    const [height, setHeight] = useState(0);
    return (
        <FloatingInputBarContext.Provider value={{ height, setHeight }}>
            {children}
        </FloatingInputBarContext.Provider>
    );
}

export function useFloatingInputBarHeight() {
    return useContext(FloatingInputBarContext);
}
